// mixins/device.js
export default {
    data() {
        return {
            deviceType: 'desktop', // mobile, tablet, desktop
            screenWidth: 0
        }
    },

    computed: {
        isMobile() {
            return this.deviceType === 'mobile'
        },

        isTablet() {
            return this.deviceType === 'tablet'
        },
        isRowTablet(){
            return this.deviceType === 'rowTablet'
        },

        isDesktop() {
            return this.deviceType === 'desktop'
        },

        // 响应式断点计算属性
        breakpoint() {
            if (this.screenWidth < 576) return 'xs'
            if (this.screenWidth < 768) return 'sm'
            if (this.screenWidth < 992) return 'md'
            if (this.screenWidth < 1200) return 'lg'
            return 'xl'
        }
    },

    methods: {
        updateDeviceType() {
            const width = window.innerWidth
            this.screenWidth = width

            // 根据需求调整断点
            if (width < 768) {
                this.deviceType = 'mobile'
            } else if (width >= 768 && width < 1024) {
                // 平板设备，可以通过 UA 进一步确认
                // const ua = navigator.userAgent.toLowerCase()
                // if (ua.includes('ipad') ||
                //     (ua.includes('macintosh') && 'ontouchend' in document)) {
                    this.deviceType = 'tablet'
                // } else {
                //     // 桌面端在小窗口时
                //     this.deviceType = 'desktop'
                // }
            }else if (width >= 1024 && width < 1600) {
                this.deviceType = 'rowTablet' || 'desktop'
            } else {
                this.deviceType = 'desktop'
            }
            // 触发自定义事件
            this.$emit('device-change', this.deviceType)
        },

        // 节流函数
        throttleResize: _.throttle(function() {
            this.updateDeviceType()
        }, 200)
    },

    mounted() {
        this.updateDeviceType()
        window.addEventListener('resize', this.throttleResize)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.throttleResize)
    }
}
